import Emitter from "./Emitter";

export default class SoundOff extends Emitter {
    constructor(gb) {
        super(gb);
    }

    F1X2_handler() {
        this.emitGame("audio-disable");
    }

    SLINGO_handler() {
        this.emitGame({ event: "soundOff" });
    }

    IGT_handler() {
        this.emitGame(JSON.stringify({ message: "cust2rgToggleSound", Params: "false" }));
    }

    PNG_handler() {
        this.emitGame({ messageType: "request", request: "soundOff" });
    }

    EDICT_handler() {
        this.emitGame("disableAudio");
    }

    // GSYSB_handler() {
    //     this.emitGame({ event: "soundOff"});
    // }

    // GSYSP_handler() {
    //     this.emitGame({ event: "soundOff"});
    // }

    BGS_handler() {
        this.emitGame({ event: "soundOff"});
    }

    RGU_handler() {
        this.emitGame({ event: "soundOff"});
    }

    RAW_handler() {
        this.emitGame({ event: "soundOff"});
    }

    HB_handler() {
        this.emitGame({ event: "soundOff"});
    }

    SPRIBE_handler() {
        this.emitGame({
            cmd: 'ifc.set.sound', data: {value: false},
        })
    }

    HI5_handler() {
        window.postMessage({cmd:"hi5_mute",value: true},"*");
    }

    HKS_handler() {
        this.emitGame({actionType:'toggleSound', actionData: {soundOn: false}});
    }

    SYN_handler() {
        this.emitGame({event: "p2g.gameAudioMute"})
    }

    KAJ_handler() {
        this.emitGame({'method': 'gel.audio.mute'});
    }

    ISOFT_handler() {
        this.emitGame('MUTE_SOUNDS');
    }

    YGG_handler() {
        this.emitGame({event:"audio/mute"})
    }

    PT_handler() {
        this.emitGame(JSON.stringify({
            "_type": "ucip.sound.w2gSoundUpdateNotification",
            "mute": true
        }))
    }

    HBN_handler() {
        this.emitGame({type: "audio", mute: true, level: 0})
    }

    SPIN_handler() {
        // not correct msg
        this.emitGame({"event":"volume","isOn":false})
    }

    ENDOR_handler() {
        this.emitGame({
            messageId: "updateSettings",
            mute: true
        });
    }

    _default() {
        this.emitGame({ wpgaction: "soundOff" });
    }
}
